import React from 'react';

import './SvgUltimateGuitar.less';

const SvgUltimateGuitar = ({ style }: SvgUltimateGuitarTypes) => (
	<svg className="svg-ultimate-guitar" style={style} viewBox="0 0 40 40">
		<path d="m5 3.4 3.25 9.15C9.2 9.85 11.7 6.8 15.8 6.8c4.3 0 6.95 3.15 7.45 6.6h6.8L33.25 1 25.7 4.9c-1.8-1.5-4.15-2.35-6.7-2.35-3.45 0-6 1.4-7.7 3.3L5 3.4zM18.5 21.65 36 13.4v14.9l-3.65-1.4C30.3 33.15 25.6 37.6 18.4 37.6c-8 0-13.6-6.25-13.6-13.9 0-2.25.45-4.1 1.25-5.9h.1a13.79 13.79 0 0 0-.65 4.3c0 6.05 4.6 10.6 10.55 10.6 5.3 0 8.7-3.7 10.3-8.05l-7.85-3z" />
	</svg>
);

type SvgUltimateGuitarTypes = {
	style?: React.CSSProperties;
};

export default SvgUltimateGuitar;
